/**
 * Enum representing subscription state and status events.
 *
 * Usage:
 *   Event.Subscription.StatusUpdated
 *   Event.Subscription.Expired
 *
 * These events are dispatched by the Subscription store module
 * when subscription state changes occur.
 *
 * @author Matt Kenefick <matt@polymermallard.com>
 * @package Event
 * @project ChalkySticks
 */
export enum Subscription {
	Expired = 'app:subscription:expired',
	OfferingsError = 'app:subscription:offerings:error',
	OfferingsFetched = 'app:subscription:offerings:fetched',
	PurchaseCancelled = 'app:subscription:purchase:cancelled',
	PurchaseError = 'app:subscription:purchase:error',
	PurchaseSuccess = 'app:subscription:purchase:success',
	RestoreEmpty = 'app:subscription:restore:empty',
	RestoreError = 'app:subscription:restore:error',
	RestoreSuccess = 'app:subscription:restore:success',
	StatusUpdated = 'app:subscription:status:updated',
}
